export class SuspendedTicket {
    constructor(
        public TicketID: number,
        public LockedBy: string,
        public QueueCategory: string,
        public Creation: Date,
        public SuspendedCount: number,
        public GCTicketID: number,
        public GCTicketNumber: number,
        public DeferredBy: string
    ) { }
}